import api from './apiService';

class Cycle {
  static get() {
    return api.get('/cycles');
  }
}

export default Cycle;



// WEBPACK FOOTER //
// ./src/api/cycleApi.js